export default __webpack_public_path__ + "static/media/icon-titulo-experiencias.39f1f8b4.svg";